import type { ReactNode } from 'react';
import { DarkBackground } from './DarkBackground';

type PageShellProps = {
  children: ReactNode;
  showGrid?: boolean;
};

export function PageShell({ children, showGrid = true }: PageShellProps) {
  return (
    <div className="flex min-h-screen flex-col overflow-x-hidden bg-slate-50 text-ink-900 dark:bg-background dark:text-foreground">
      <div className="dark:block hidden">
        <DarkBackground variant="page" showGrid={showGrid} />
      </div>
      <div className="relative z-10 flex min-h-screen flex-1 flex-col">{children}</div>
    </div>
  );
}
